import styled from "styled-components";

export const Container = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 8px;
  display: flex;
  align-items: center;
  &.disabled {
    background-color: #d6d6d6;
    opacity: 0.5;
    border-color: #acacac;
    &:hover {
      cursor: not-allowed;
      color: ${(props) => props.colorHover || "#FFF"};
    }
  }
  @media (max-width: 1024px) {
    height: ${(props) => props.height1024 || "48px"};
    width: 100%;
  }
`;

export const Element = styled.input`
  direction: ltr;
  /* background: ${(props) => props.background}; */
  outline: none;
  border: none;
  width: ${(props) => (!props.leftIcon || !props.rightIcon ? "50%" : "99%")};
  height: 85%;
  box-sizing: border-box;
  ::placeholder {
    color: ${(props) => props.placeholderColor};
    opacity: 1;
  }
  padding-right: 8px;
  font-weight: 500;
  font-size: 16px;
  text-align: right;
  color: ${(props) => props.fontColor};

  &.disabled {
    /* background-color: #d6d6d6; */
    opacity: 0.5;
    border-color: #e9ebf8;
    &:hover {
      cursor: not-allowed;
      color: ${(props) => props.colorHover || "#FFF"};
    }
  }
`;

export const IconContainer = styled.div`
  margin-left: ${(props) => (props.leftIcon ? "5px" : "0")};
  margin-right: ${(props) => (props.rightIcon ? "5px" : "0")};
  width: 10%;
  height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: ${(props) => (props.toggleType ? "pointer" : "")};
  & svg {
    width: 24px;
    height: 24px;
    fill: #27548c;
  }
`;

export const Icon = styled.img`
  /* filter: invert(57%) sepia(74%) saturate(633%) hue-rotate(187deg)
    brightness(93%) contrast(95%); */
`;

export const LabelContainer = styled.div`
  text-align: right;
  label {
    color: ${(props) => props.color};
  }
`;
